import { handleActions } from 'redux-actions'
import {
  setVerifyEmailContext,
  verifyEmailCode,
  verifyEmailCodeSuccess,
  verifyEmailCodeFail,
  resendVerificationCode,
  resendVerificationCodeSuccess,
  resendVerificationCodeFail,
  VerifyEmailPurpose,
} from './VerifyEmailActions'

export interface IVerifyEmailState {
  loading: boolean
  error: string | null
  resending: boolean
  purpose: VerifyEmailPurpose
  email: string
}

const initialState: IVerifyEmailState = {
  loading: false,
  error: null,
  resending: false,
  purpose: 'LOGIN',
  email: '',
}

export const verifyEmailReducer = handleActions<IVerifyEmailState, any>(
  {
    [String(setVerifyEmailContext)]: (state, action) => ({
      ...state,
      purpose: action.payload?.purpose || 'LOGIN',
      email: action.payload?.email || '',
      error: null,
    }),
    [String(verifyEmailCode)]: (state) => ({ ...state, loading: true, error: null }),
    [String(verifyEmailCodeSuccess)]: (state) => ({ ...state, loading: false, error: null }),
    [String(verifyEmailCodeFail)]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload || 'invalidCode',
    }),
    [String(resendVerificationCode)]: (state) => ({ ...state, resending: true, error: null }),
    [String(resendVerificationCodeSuccess)]: (state) => ({ ...state, resending: false }),
    [String(resendVerificationCodeFail)]: (state) => ({ ...state, resending: false }),
  },
  initialState,
)
